import { useTranslation } from 'react-i18next';
import { Award, Hammer, Users } from 'lucide-react';
import { SEO } from '../seo/SEO';

export function AboutPage() {
  const { t } = useTranslation();

  const values = [
    { icon: Hammer, key: 'craft' },
    { icon: Award, key: 'quality' },
    { icon: Users, key: 'service' },
  ] as const;

  return (
    <section className="max-w-editorial mx-auto px-6 sm:px-10 py-20">
      <SEO titleKey="seo.about.title" descriptionKey="seo.about.description" />
      <div className="grid grid-cols-12 gap-8 mb-20">
        <div className="col-span-12 md:col-span-3">
          <span className="editorial-number text-5xl block">N°02</span>
          <div className="editorial-label mt-3">— Atelier</div>
          <div className="editorial-rule mt-6 max-w-[3rem]" />
        </div>
        <div className="col-span-12 md:col-span-9">
          <h1 className="font-display text-[clamp(3rem,6vw,5.5rem)] leading-[0.95] tracking-tight text-ink">
            {t('about.title').split(' ').slice(0, -1).join(' ')}{' '}
            <span className="italic text-brass">{t('about.title').split(' ').slice(-1).join(' ')}</span>
          </h1>
          <p className="mt-8 font-display text-2xl italic text-ink-soft leading-snug max-w-3xl">
            {t('about.lead')}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-12 gap-8 mb-24">
        <div className="col-span-12 md:col-span-2 md:col-start-2">
          <span className="editorial-label text-brass">— Manifeste</span>
        </div>
        <div className="col-span-12 md:col-span-7 font-body text-base text-ink-soft leading-relaxed space-y-6">
          <p>{t('about.body1')}</p>
          <p>{t('about.body2')}</p>
        </div>
      </div>

      <div className="border-t border-linen pt-12">
        <div className="grid grid-cols-12 gap-8 mb-10">
          <div className="col-span-12 md:col-span-3">
            <span className="editorial-number text-3xl">III.</span>
          </div>
          <div className="col-span-12 md:col-span-9">
            <h2 className="font-display text-4xl italic">{t('about.valuesTitle')}</h2>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-x-8 gap-y-12">
          {values.map(({ icon: Icon, key }, i) => (
            <article key={key} className="border-t border-linen pt-6">
              <div className="flex items-center justify-between mb-4">
                <span className="editorial-number text-2xl">{String(i + 1).padStart(2, '0')}</span>
                <Icon className="w-5 h-5 text-brass" />
              </div>
              <h3 className="font-display text-2xl italic mb-3">{t(`about.values.${key}.title`)}</h3>
              <p className="font-body text-sm text-ink-soft leading-relaxed">
                {t(`about.values.${key}.body`)}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
